import styles from './quickDisassembly.module.css';
import DOMPurify from 'dompurify';
import CircleStyleTextBox from '../circleStyleTextBox/circleStyleTextBox';
import { useState } from 'react';

const QuickDisassembly = ({ m2sText }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  return (
    <div className={`${styles.ctn} m2s-section`}>
      <CircleStyleTextBox className={styles.textBox}>
        <h2
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(m2sText['text12']),
          }}
        ></h2>

        <div className={styles.tabBox}>
          {[m2sText['text13'], m2sText['text14']].map((item, index) => {
            return (
              <div
                className={`${activeTabIndex === index ? 'active' : ''}`}
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setActiveTabIndex(index);
                }}
              >
                            <div className={styles.tabLine}></div>
                {item}
              </div>
            );
          })}
        </div>

        <div
          style={{
            position: 'relative',
          }}
        >
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(m2sText['text15']),
            }}
            style={{
              position: 'absolute',
              opacity: activeTabIndex === 0 ? 1 : 0,
            }}
          ></h5>

          <div
            style={{
              opacity: activeTabIndex === 0 ? 0 : 1,
            }}
          >

            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text16']),
              }}
            ></h5>
            <h6>{m2sText['text17']}</h6>
          </div>
        </div>
      </CircleStyleTextBox>

      <div
        style={{
          position: 'relative',
        }}
      >
        <video
          className={styles.img}
          autoPlay
          loop
          playsInline
          muted
          src={`https://bucket.zhiyun-tech.com/detail/m2s/m2s-quickrelease-standard.mp4`}
          alt=""
          style={{
            position: 'absolute',
            opacity: activeTabIndex === 0 ? 1 : 0,
          }}
        />
        <video
          className={styles.img}
          autoPlay
          loop
          playsInline
          muted
          src={`https://bucket.zhiyun-tech.com/detail/m2s/m2s-quickrelease-dedicated.mp4`}
          alt=""
          style={{
            opacity: activeTabIndex === 0 ? 0 : 1,
          }}
        />
      </div>
    </div>
  );
};

export default QuickDisassembly;
